import { createContext, useEffect, useState } from 'react';
import { MerchantAccount, MerchantAccountsResponse, MerchantAccountResponse, CountriesResponse, Country, CatalogTariffResponse, Catalog, PaymentType, CatalogMerchAccountResponse, AccountBank } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type MerchantAccountsContextProps = {
    merchantAccounts: MerchantAccount[];
    countries: Catalog[];
    currencies: Catalog[];
    banks: AccountBank[];
    accountTypes: Catalog[];
    totalPage: number;
    loadMerchantAccounts: (merchantId: number, page: number) => Promise<void>;
    loadCatalogs: () => Promise<void>;
    addMerchantAccount: (merchantAccount: MerchantAccount) => Promise<string>;
    updateMerchantAccount: (merchantAccount: MerchantAccount) => Promise<string>;
    deleteMerchantAccount: (merchantAccount: MerchantAccount) => Promise<string>;

}



export const MerchantAccountsContext = createContext({} as MerchantAccountsContextProps);

export const MerchantAccountsProvider = ({ children }: any) => {

    const [merchantAccounts, setMerchantAccounts] = useState<MerchantAccount[]>([]);
    const [countries, setCountries] = useState<Catalog[]>([]);
    const [currencies, setCurrencies] = useState<Catalog[]>([]);
    const [banks, setBanks] = useState<AccountBank[]>([]);
    const [accountTypes, setAccountTypes] = useState<Catalog[]>([]);

    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    const loadCatalogs = async () => {

        const resp = await topApi.get<CatalogMerchAccountResponse>('/merchantAccount/getCatalogsForMerchantAccounts');
        if (resp.status == 200) {
            setCountries(resp.data.countries);
            setCurrencies(resp.data.currencies);
            setBanks(resp.data.banks);
            setAccountTypes(resp.data.accountTypes);
            setTotalPage(1);
        }


    }


    const loadMerchantAccounts = async (merchantId, pageActual) => {

        const resp = await topApi.get<MerchantAccountsResponse>('/merchantAccount/getMerchantAccounts/' + merchantId);
        if (resp.status == 200) {
            setMerchantAccounts([...resp.data.merchantAccounts]);
            setTotalPage(1);
        }


    }

    const addMerchantAccount = async (merchantAccount: MerchantAccount) => {
        try {

            const resp = await topApi.post<MerchantAccountResponse>('/merchantAccount/', { merchantAccount });
            setMerchantAccounts([...merchantAccounts, resp.data.merchantAccount]);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }


    const updateMerchantAccount = async (merchantAccount: MerchantAccount) => {
        try {
            const resp = await topApi.put<MerchantAccount>(`/merchantAccount/`, { merchantAccount });

            setMerchantAccounts(merchantAccounts.map(prod => {
                return (
                    prod.merchantId === merchantAccount.merchantId &&
                    prod.currencyId === merchantAccount.currencyId
                )
                    ? resp.data["merchantAccount"]
                    : prod;
            }));


            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }


    }

    const deleteMerchantAccount = async (merchantAccount: MerchantAccount) => {
        try {
            await topApi.delete<MerchantAccount>(`/merchantAccount/${merchantAccount.currencyId}/${merchantAccount.merchantId}`);
            setMerchantAccounts((prevMerchantAccounts) =>
                prevMerchantAccounts.filter((prod) =>
                    !(
                        prod.merchantId === merchantAccount.merchantId &&
                        prod.currencyId === merchantAccount.currencyId
                    )
                )
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }



    return (
        <MerchantAccountsContext.Provider value={{
            merchantAccounts, countries,
            currencies,
            banks,
            accountTypes, totalPage, loadMerchantAccounts, addMerchantAccount, updateMerchantAccount, deleteMerchantAccount, loadCatalogs
        }}>
            {children}
        </MerchantAccountsContext.Provider>
    );
}